import downloadAPI from '@/api/downloadAPI'

const state = {

}

const getters = {

}

const actions = {
  sign ({ commit }, url) {
    // commit('setLoading', true, { root: true })
    return new Promise((resolve, reject) => {
      downloadAPI.sign(url)
        .then(resp => {
          console.log(resp)
          resolve(resp.data.protectedURL)
          // commit('setLoading', false, { root: true })
          // commit('setChecklist', resp.data.checklist)
        })
        .catch(error => {
          reject(error)
          // commit('setLoading', false, { root: true })
          // commit('setError', error, { root: true })
          // console.log(error)
        })
    })
  }
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
